import { render, staticRenderFns } from "./ProductsSerials.vue?vue&type=template&id=626fd4a0&scoped=true&"
import script from "./ProductsSerials.vue?vue&type=script&lang=js&"
export * from "./ProductsSerials.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSerials.vue?vue&type=style&index=0&id=626fd4a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626fd4a0",
  null
  
)

export default component.exports